import Box from '@mui/material/Box'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { grey } from '@mui/material/colors'
import { type ElementType } from 'react'

interface ExpandableCellProps {
  expanded: boolean
  toggleExpandHandler: () => void
  children: React.ReactNode
  rowId: string
}

export const iconWidth = 22
export const iconMargin = 8

const resolveIconComponent = (iconSource: unknown): ElementType => {
  if (iconSource && typeof iconSource === 'object' && 'default' in iconSource) {
    return (iconSource as { default: ElementType }).default
  }

  return iconSource as ElementType
}

export const ExpandableCell = ({
  expanded,
  toggleExpandHandler,
  children,
  rowId,
}: ExpandableCellProps) => {
  const iconSource = expanded ? KeyboardArrowDownIcon : KeyboardArrowRightIcon
  const Icon = resolveIconComponent(iconSource)
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {Icon ? (
        <Icon
          sx={{
            width: `${iconWidth}px`,
            mr: `${iconMargin}px`,
            color: expanded ? 'primary.main' : grey[500],
          }}
          onClick={toggleExpandHandler}
          data-testid={
            expanded ? `collapse-icon-${rowId}` : `expand-icon-${rowId}`
          }
          className="expandable-table-chevron"
        />
      ) : null}
      {children}
    </Box>
  )
}
